const VARIANT_SCORE_VARIANT_TYPES = {
  'PREDICTED_OR_PROVEN_NULL': 'Predicted or proven null',
  'OTHER_VARIANT_TYPE': 'Other Variant Type'
};
export default VARIANT_SCORE_VARIANT_TYPES;
